import React from 'react';
import './MainApp.css';
import "../Utils/Colors/MainColors.css"
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import TermsOfService from '../Views/Landing/TermsOfService/TermsOfService';
import PrivacyPolicy from '../Views/Landing/PrivacyPolicy/PrivacyPolicy';
import TestIcon from '../Components/TestIcon';
import Support from '../Views/Landing/PrivacyPolicy/Support';
import AdvertiseWithUs from '../Views/Landing/AdvertiseWithUs/AdvertiseWithUs';
import DeleteAccountRequest from '../Views/Landing/DeleteAccountRequest/DeleteAccountRequest';
import CSAEStandards from '../Views/Landing/CSAEStandards/CSAEStandards';
import SpecialThanks from '../Views/Landing/SpecialThanks/SpecialThanks';
import WikipediaImageIndexer from '../Views/WIkiIndexing/WikipediaImageIndexer';

import PeaColonyWeb from '../Hung/PeaColonyWeb/PeaColonyWeb';
import ContentSearch from '../Views/ContentSearch/ContentSearch';
// import AuthView, { AuthView_JustASecond } from '../Components/AuthView/AuthView';

/**
 * Performance Optimizations:
 * - Uses React.lazy() for code splitting
 * - Components will only be loaded when needed based on auth state
 * - Added loading fallback with Suspense
 * - Improves initial bundle size and load performance
 */

// Lazy load components
const Landing = React.lazy(() => import('../Views/Landing/Landing'));
const Colony = React.lazy(() => import('../Views/ColonyApp/Colony/Colony'));

const MainApp = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={
              <div className="App">
                <Landing />
              </div>
          } />

        <Route path="/icon" element={ <TestIcon /> } />
        <Route path="/terms-of-service" element={ <TermsOfService/> } />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/support" element={<Support/>} />
        <Route path="/delete-account-request" element={<DeleteAccountRequest />} />
        <Route path="/csae-standards" element={<CSAEStandards/>} />
        <Route path="/advertise" element={<AdvertiseWithUs/>} />
        <Route path="/special-thanks" element={<SpecialThanks/>} />
        {/*  */}
        {/* <Route path="/peac___" element={ <PeaColonyWeb />} /> */}
        {/* <Route path="/pre_launch______________1290-124+ahasdfad_ajfbeoaahigualopab152757206729438" element={ <PeaColonyWeb />} /> */}
        
        <Route path="/wiki-indexing" element={<WikipediaImageIndexer/>} />

        <Route path="/search_pea_colony" element={<ContentSearch/>} />

      </Routes>
    </BrowserRouter>

      
  );
}
export default MainApp;

/*

We are about to launch a web version of our mobile app PeaColony. The link we placed in there is a demo version for anyone to play around with while we get everything ready to launch the full version for web. We want to use Amazon ads to bring in revenue for the site along with a few other third party ad publisher add tools.

https://peacolony.com/pre_launch______________1290-124+ahasdfad_ajfbeoaahigualopab152757206729438

*/
